class Collection extends HTMLElement {
  //? shop domain and access token
  //? own
  // SHOP_DOMAIN = "learning-theme-basics.myshopify.com";
  // STOREFRONT_ACCESS_TOKEN = "e6298227475437a1f239f8a9e89a1ac6";
  //? sandbox
  SHOP_DOMAIN = location.hostname || "epd-parts-sandbox.myshopify.com";
  STOREFRONT_ACCESS_TOKEN = "3a296c09409d55b09fb31e2eb7989e64";
  PAGE_SIZE = 12;
  COLLECTION_HANDLE = "all-new";

  //? pagination
  PAGE_INFO = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: null,
    endCursor: null,
  };

  //? query variables
  QUERY_VARIABLES = {
    handle: this.COLLECTION_HANDLE,
    first: this.PAGE_SIZE,
    before: null,
    after: null,
    sortKey: null,
    filters: [],
    reverse: false,
  };

  //? locale
  localRegion = {
    USD: "en-US",
    EUR: "en-GB",
    GBP: "en-GB",
    CAD: "en-CA",
    INR: "en-IN",
  };

  //? sort by reverse options
  reverseOptions = [
    "title-descending",
    "price-descending",
    "created-descending",
  ];

  //? sort by options suitable query
  sortByQueryOptions = {
    manual: "MANUAL",
    "best-selling": "BEST_SELLING",
    "title-ascending": "TITLE",
    "title-descending": "TITLE",
    "price-ascending": "PRICE",
    "price-descending": "PRICE",
    "created-ascending": "CREATED",
    "created-descending": "CREATED",
  };

  //? sort by filter value and labels (not used now)
  sortByOptions = [
    {
      label: "Featured",
      value: "manual",
    },
    {
      label: "Best selling",
      value: "best-selling",
    },
    {
      label: " Alphabetically, A-Z",
      value: "title-ascending",
    },
    {
      label: "Alphabetically, Z-A",
      value: "title-descending",
    },
    {
      label: "Price, low to high",
      value: "price-ascending",
    },
    {
      label: "Price, high to low",
      value: "price-descending",
    },
    {
      label: "Date, old to new",
      value: "created-ascending",
    },
    {
      label: "Date, new to old",
      value: "created-descending",
    },
  ];

  //? metafield filters ids
  metafieldFiltersIds = [
    "filter.p.m.custom.manufacturer",
    "filter.p.m.custom.model",
  ];

  //? checked filters (manufacturer, model, product type)
  CHECKED_FILTERS_VALUES = {
    manufacturer: new Set(),
    model: new Set(),
    productType: new Set(),
  };

  //? results counts
  RESULTS_COUNTS = {
    total: 0,
    startCount: 0,
    endCount: 0,
  };

  constructor() {
    super();
  }

  // ? initial render
  connectedCallback() {
    //? elements
    this.collectionTitle = this.querySelector(".collection__title");
    this.loadMoreBtnWrapper = this.querySelector(".collection__load-more");
    this.productsContainer = this.querySelector(".collection__products--grid");
    this.sortByFilterEl = this.querySelector("#sort-by-filter");
    this.brandFilterEl = this.querySelector("#manufacturer-filter");
    this.modelFilterEl = this.querySelector("#model-filter");
    this.collectionMetaEl = this.querySelector(".collection__meta");
    this.appliedCollectionFiltersWrapper = this.querySelector(
      ".collection__applied-filters"
    );
    this.mainSection = document.getElementById("MainContent");
    this.pageBody = document.querySelector("body");
    this.headerWrapper = document.querySelector(".main-header-wrapper");
    this.cartPopup = document.querySelector(".cart-notification");

    //? initial render
    this.initialRender();

    //? render sort by filter options
    // this.renderSortByFilterOptions();

    //? event listeners
    this.addEventListener("click", (e) => {
      //? load more btn click
      if (e.target.closest(".collection__load-more--button")) {
        this.loadMoreProducts(this.PAGE_INFO.endCursor);
        return;
      }

      //? add to cart
      if (e.target.closest(".product-card__add-to-cart")) {
        //? add to cart element
        const addToCartBtnEl = e.target.closest(".product-card__add-to-cart");
        //? prevent default
        e.preventDefault();
        e.stopPropagation();
        const variantId = Number.parseInt(
          addToCartBtnEl.getAttribute("data-variant-id"),
          10
        );

        //? add overlay
        this.showOverlayUI();

        //? call add to cart function
        this.addToCart(variantId, addToCartBtnEl);
        return;
      }

      //? cart nortification close btn
      if (e.target.closest(".cart-notification__close")) {
        this.hideOverlayUI();
        return;
      }

      //? listen filter
      if (e.target.closest(".dropdown-filter__trigger")) {
        this.openDropdownFilter(e);
        return;
      }

      //? sort by filter options
      if (
        e.target.closest(".dropdown-filter__option") &&
        !e.target.closest(
          ".dropdown-filter__option.dropdown-filter__option--checkbox"
        )
      ) {
        this.filterBySortBy(e);
        return;
      }

      //? breadcrumb filter links
      if (e.target.closest(".collection__breadcrumb__filter-link")) {
        this.filterByBreadcrumbLink(e);
        return;
      }

      //? applied filter clear icon
      if (e.target.closest(".applied-filter-clear-icon")) {
        this.clearAppliedFilter(e);
        return;
      }

      //? breadcrumb main link click
      if (e.target.closest(".collection__breadcrumb__link")) {
        this.filterByBreadcrumbMainLink(e);
        return;
      }
    });

    //? change listen
    this.addEventListener("change", (e) => {
      if (
        e.target.closest(
          ".dropdown-filter__option.dropdown-filter__option--checkbox"
        )
      ) {
        this.filterByMetafield(e);
        return;
      }
    });

    //? listener to close dropdown when click outside
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".dropdown-filter")) {
        this.closeDropdownFilters();
      }
      //? hide overly
      if (
        this.pageBody.classList.contains("overlay") &&
        this.cartPopup &&
        !this.cartPopup.contains(e.target)
      ) {
        // console.log("Clicked outside cart notification");
        this.hideOverlayUI();
      }
    });
  }

  showOverlayUI() {
    this.mainSection?.classList.add("overlay");
    this.pageBody?.classList.add("overlay");
    this.headerWrapper?.classList.add("overlay");
  }

  hideOverlayUI() {
    this.mainSection?.classList.remove("overlay");
    this.pageBody?.classList.remove("overlay");
    this.headerWrapper?.classList.remove("overlay");
  }

  //? open dropdown filter
  openDropdownFilter(e) {
    const triggerEl = e.target.closest(".dropdown-filter__trigger");
    const optionsEl = triggerEl.nextElementSibling;
    if (triggerEl && optionsEl) {
      if (!triggerEl.classList.contains("active")) {
        //? before all opened dropdowns
        this.closeDropdownFilters();
        optionsEl.classList.add("open");
        triggerEl.classList.add("active");
      } else {
        optionsEl.classList.remove("open");
        triggerEl.classList.remove("active");
      }
    }
  }
  //? close all dropdown filters
  closeDropdownFilters() {
    const dropdownFilters = this.querySelectorAll(".dropdown-filter");
    dropdownFilters.forEach((dropdownFilter) => {
      const triggerEl = dropdownFilter.querySelector(
        ".dropdown-filter__trigger"
      );
      const optionsEl = dropdownFilter.querySelector(
        ".dropdown-filter__options"
      );
      if (triggerEl && optionsEl) {
        optionsEl.classList.remove("open");
        triggerEl.classList.remove("active");
      }
    });
  }

  //? filter by sort by options
  filterBySortBy(e) {
    const optionEl = e.target.closest(".dropdown-filter__option");
    const value = optionEl.getAttribute("data-value");
    //? preserve url
    this.preserveUrlSearchParams("sort-by", value, true);
    //? validate
    const option = this.sortByQueryOptions[value];
    const reverseQuery = this.reverseOptions.includes(value);
    //? set reverse
    this.QUERY_VARIABLES.reverse = reverseQuery;
    //? update the option
    this.QUERY_VARIABLES.sortKey = option;
    //? apply sort by
    this.applySortBy();
    //? change label
    this.sortByFilterEl.querySelector(".dropdown-filter__label").textContent =
      optionEl.textContent;
    this.sortByFilterEl
      .querySelectorAll(".dropdown-filter__option")
      .forEach((optionEl) => {
        optionEl.classList.remove("disabled");
        if (optionEl.getAttribute("data-value") === value) {
          optionEl.classList.add("disabled");
        }
      });
    //? close dropdown
    this.closeDropdownFilters();
  }

  //? filter by metafield
  filterByMetafield(e) {
    const checkboxEl = e.target;
    const { name: checkboxName, checked, value: checkboxValue } = checkboxEl;
    const filterInput = checkboxEl.getAttribute("data-filter-input");
    //? early return if input is missing or filter limit exceeded
    if (!filterInput || this.QUERY_VARIABLES.filters.length >= 250) {
      alert("Filter limit exceeded");
      return;
    }
    //? update checked filters
    const filters = new Set(this.QUERY_VARIABLES.filters.map(JSON.stringify));
    if (checked) {
      this.CHECKED_FILTERS_VALUES[checkboxName].add(checkboxValue);
      filters.add(filterInput);
    } else {
      this.CHECKED_FILTERS_VALUES[checkboxName].delete(checkboxValue);
      filters.delete(filterInput);

      //?  manufacturer is empty remove all active filters
      if (
        checkboxName === "manufacturer" &&
        this.CHECKED_FILTERS_VALUES["manufacturer"].size === 0
      ) {
        //? remove all filters
        this.CHECKED_FILTERS_VALUES["model"].clear();
        this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
          (filter) =>
            filter?.productMetafield?.key !== "manufacturer" &&
            filter?.productMetafield?.key !== "model"
        );
        //? remove url search params
        this.preserveUrlSearchParams("model", "", true);
        this.preserveUrlSearchParams("manufacturer", "", true);

        //? re render not needed for manufacturer filter after initial render
        this.applyFilters();

        //? filter label update
        this.updateMetafieldFilterLabel("manufacturer", "Brand", true);
        this.updateMetafieldFilterLabel("model", "Model", true);

        return;
      } //? suppose manufacturer deselected but model is active then remove active model beyond to manufacturer
      else if (checkboxName === "manufacturer") {
        //? get all cards with matches with manufacturer
        this.querySelectorAll(
          ".product-card[data-manufacturer=" +
            checkboxValue.replaceAll(" ", "-") +
            "]"
        ).forEach((card) => {
          const modelValue = card.getAttribute("data-model");
          //? early return
          if (!modelValue) return;
          this.CHECKED_FILTERS_VALUES["model"].delete(modelValue);
          this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
            (filter) => filter?.productMetafield?.value !== modelValue
          );
        });

        //? remove all models and that manufacturer
        this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
          (filter) => filter?.productMetafield?.value !== checkboxValue
        );
        //? update url search params
        this.preserveUrlSearchParams(
          "model",
          [...this.CHECKED_FILTERS_VALUES["model"]],
          true
        );
        this.preserveUrlSearchParams(
          checkboxName,
          [...this.CHECKED_FILTERS_VALUES[checkboxName]],
          true
        );
        //? re render not needed for manufacturer filter after initial render
        this.applyFilters();

        //? filter label update
        this.updateMetafieldFilterLabel("model", "Model", false);
        this.updateMetafieldFilterLabel("manufacturer", "Brand", false);

        return;
      }
    }
    //? update filters (url and query)
    this.QUERY_VARIABLES.filters = Array.from(filters).map(JSON.parse);
    this.preserveUrlSearchParams(
      checkboxName,
      [...this.CHECKED_FILTERS_VALUES[checkboxName]],
      true
    );

    //? apply filters
    this.applyFilters();

    //? update filter label textContent
    this.updateMetafieldFilterLabel(
      checkboxName,
      checkboxName === "manufacturer" ? "Brand" : "Model",
      false
    );
  }

  //? filter by breadcrumb main breadcrumb link
  filterByBreadcrumbMainLink(e) {
    e.preventDefault();

    const searchParams = new URLSearchParams(window.location.search);

    //? new request needed or not (because url has collection param only exist in searchParams not applies any filters)
    const neededRequest =
      searchParams.has("manufacturer") ||
      searchParams.has("model") ||
      searchParams.has("sort-by");

    //? apply filters
    if (neededRequest) {
      //? reset metafield filters url and checked values
      this.preserveUrlSearchParams("manufacturer", "", true);
      this.preserveUrlSearchParams("model", "", true);
      this.CHECKED_FILTERS_VALUES["manufacturer"].clear();
      this.CHECKED_FILTERS_VALUES["model"].clear();

      //? change labels to metafield filters
      this.updateMetafieldFilterLabel("manufacturer", "Brand", true);
      this.updateMetafieldFilterLabel("model", "Model", true);

      //? remove sort by filter
      this.clearAppliedSortByFilter();

      //? only keep productType filter
      if (this.QUERY_VARIABLES.filters.length) {
        this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
          (filter) => "productType" in filter
        );
      }

      //? push url to history
      history.pushState(null, null, e.target.href);

      //? apply filters
      this.applyFilters();
    }
  }

  //? filter by breadcrumb metafield filter link
  filterByBreadcrumbLink(e) {
    //? prevent default
    e.preventDefault();

    //? prevent bubbling
    e.stopPropagation();

    //? get filter input
    const breadcrumbLinkEl = e.target;
    const filterInput = breadcrumbLinkEl.getAttribute("data-filter-input");

    if (filterInput) {
      // console.log(this.QUERY_VARIABLES.filters);
      const parseFilterInput = JSON.parse(filterInput);

      //? clear checked values and filters
      this.CHECKED_FILTERS_VALUES["manufacturer"].clear();
      this.CHECKED_FILTERS_VALUES["model"].clear();
      this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
        (filter) =>
          filter?.productMetafield?.key !== "manufacturer" &&
          filter?.productMetafield?.key !== "model"
      );

      //? close model model dropdown
      this.modelFilterEl.classList.add("disabled");
      this.modelFilterEl
        .querySelector(".dropdown-filter__trigger")
        .classList.remove("active");
      this.modelFilterEl
        .querySelector(".dropdown-filter__options")
        .classList.remove("open");
      this.modelFilterEl.setAttribute("aria-disabled", "true");

      //? add current manufacturer
      this.CHECKED_FILTERS_VALUES["manufacturer"].add(
        parseFilterInput.productMetafield.value
      );
      this.QUERY_VARIABLES.filters.push(parseFilterInput);
      //? update url search params
      this.preserveUrlSearchParams("model", "", true);
      this.preserveUrlSearchParams(
        "manufacturer",
        [...this.CHECKED_FILTERS_VALUES["manufacturer"]],
        true
      );

      //? apply filters
      this.applyFilters();

      //? filter label update
      this.updateMetafieldFilterLabel("manufacturer", "Brand");
      this.updateMetafieldFilterLabel("model", "Model", true);
    }
  }

  //? remove applied metafield filter
  clearAppliedFilter(e) {
    const spanEl = e.target.closest(".applied-filter-clear-icon");
    const filterInput = spanEl.getAttribute("data-filter-input");

    if (filterInput) {
      const parseFilterInput = JSON.parse(filterInput);

      //? clear checked values and filters
      this.CHECKED_FILTERS_VALUES[parseFilterInput.productMetafield.key].delete(
        parseFilterInput.productMetafield.value
      );

      this.QUERY_VARIABLES.filters = this.QUERY_VARIABLES.filters.filter(
        (filter) =>
          filter?.productMetafield?.value !==
          parseFilterInput.productMetafield.value
      );

      //? update url search params
      this.preserveUrlSearchParams(
        parseFilterInput.productMetafield.key,
        [...this.CHECKED_FILTERS_VALUES[parseFilterInput.productMetafield.key]],
        true
      );

      //? apply filters
      this.applyFilters();

      //? filter label update
      this.updateMetafieldFilterLabel(
        parseFilterInput.productMetafield.key,
        parseFilterInput.productMetafield.key === "manufacturer"
          ? "Brand"
          : "Model"
      );
    }
  }

  //? remove sort by filter
  clearAppliedSortByFilter() {
    //? set reverse to false
    this.QUERY_VARIABLES.reverse = false;
    //? set sort by to null
    this.QUERY_VARIABLES.sortKey = null;

    //? remove disabled class
    this.sortByFilterEl
      .querySelectorAll(".dropdown-filter__option")
      .forEach((optionEl) => {
        if (optionEl.classList.contains("disabled")) {
          optionEl.classList.remove("disabled");
        }
      });
    this.sortByFilterEl.querySelector(".dropdown-filter__label").textContent =
      "Best selling";
  }

  //? format price
  getFormatPrice(amount, locale, currency) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    }).format(Number.parseFloat(amount));
  }

  //?  get collection handle
  getCollectionHandle() {
    try {
      const url = window.location.pathname;
      const pathParts = url.split("/").filter(Boolean);
      const collectionIndex = pathParts.indexOf("collections");
      if (collectionIndex !== -1 && pathParts.length > collectionIndex + 1) {
        return pathParts[collectionIndex + 1];
      }
      return null;
    } catch (error) {
      console.error("Error extracting collection handle:", error);
      return null;
    }
  }

  //? get sortby from url
  getSortByValueFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);
    const value = searchParams.get("sort-by");

    if (value) {
      //? validate
      const option = this.sortByQueryOptions[value];
      const reverseQuery = this.reverseOptions.includes(value);
      //? set reverse
      this.QUERY_VARIABLES.reverse = reverseQuery;
      //? update the option
      this.QUERY_VARIABLES.sortKey = option;

      //? change label
      this.sortByFilterEl
        .querySelectorAll(".dropdown-filter__option")
        .forEach((optionEl) => {
          if (optionEl.getAttribute("data-value") === value) {
            optionEl.classList.add("disabled");
            this.sortByFilterEl.querySelector(
              ".dropdown-filter__label"
            ).textContent = optionEl.textContent;
          }
        });
    }
  }

  //? get applied filters from url
  getAppliedMetaFieldFiltersFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);
    const metafieldFiltersKeys = Object.keys(this.CHECKED_FILTERS_VALUES);

    //? get applied filters
    metafieldFiltersKeys.forEach((key) => {
      if (searchParams.has(key) && searchParams.getAll(key).length !== 0) {
        searchParams.getAll(key).forEach((value) => {
          //? add to checked filters
          this.CHECKED_FILTERS_VALUES[key].add(value);
          //? push filters to make request
          this.QUERY_VARIABLES.filters.push({
            productMetafield: {
              namespace: "custom",
              key: key,
              value: value,
            },
          });
          //? update textContent for filter label
          this.querySelector(
            `#${key}-filter .dropdown-filter__label`
          ).textContent =
            this.CHECKED_FILTERS_VALUES[key].size <= 0
              ? `${key === "manufacturer" ? "Brand" : "Model"}`
              : this.CHECKED_FILTERS_VALUES[key].size > 2
              ? [...this.CHECKED_FILTERS_VALUES[key]].slice(0, 2).join(", ") +
                ` ${"..."}`
              : [...this.CHECKED_FILTERS_VALUES[key]].join(", ");
        });
      }
    });
  }

  //? get applied collection (product type) filter from url
  getAppliedProductTypeFilterFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);

    //? if product type exist
    if (searchParams.has("collection")) {
      //? get value
      const value = searchParams.get("collection");
      //? add to checked filters
      this.CHECKED_FILTERS_VALUES["productType"].add(value);
      //? push filters to make request
      this.QUERY_VARIABLES.filters.push({
        productType: value,
      });
    }
  }

  //? get end cursor from url
  getEndCursorFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);

    if (!searchParams.has("phCursor")) return null;

    this.QUERY_VARIABLES.after = searchParams.get("phCursor");
    //? get phCursor from searchParams url ,not exist it will return null (that's set is default value)
    return searchParams.get("phCursor");
  }

  //? get applied filter by key for option to check
  getFilterIsApplied(key, value) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.getAll(key).includes(value);
  }

  // ? get collection
  async getCollection(
    handle = "all",
    first = this.PAGE_SIZE,
    before = null,
    after = null,
    sortKey = null,
    filters = [],
    reverse = false
  ) {
    try {
      //? variables
      const variables = {
        handle,
        first,
        before,
        after,
        sortKey,
        filters,
        reverse,
      };

      //? query
      const query = `
 query Collection(
    $handle: String!
    $first: Int
    $after: String
    $before: String
    $sortKey: ProductCollectionSortKeys
    $filters: [ProductFilter!],
    $reverse: Boolean
) {
    collection(handle: $handle) {
        title
        products(
            first: $first
            filters: $filters
            after: $after
            before: $before
            sortKey: $sortKey
            reverse: $reverse
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
                startCursor
            }
            nodes {
                id
                handle
                title
                availableForSale
                images(first: 2) {
                    nodes {
                        altText
                        url
                    }
                }
                variants(first: 2) {
                    nodes {
                        price {
                            amount
                            currencyCode
                        }
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                        title
                        id
                        availableForSale
                        metafield(key: "image_url", namespace: "custom") {
                            id
                            key
                            namespace
                            value
                        }
                    }
                }
                  metafields(
                    identifiers: [
                        { key: "manufacturer", namespace: "custom" }
                        { key: "model", namespace: "custom" }
                        { key: "image_url", namespace: "custom" }
                    ]
                ) {
                    id
                    key
                    namespace
                    value
                }
            }
            filters {
                id
                label
                presentation
                type
                values {
                    count
                    id
                    input
                    label
                }
            }
        }
    }
}
  `;

      const response = await fetch(
        `https://${this.SHOP_DOMAIN}/api/2023-10/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": this.STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({ query, variables }),
        }
      );

      //? if request failed throw error
      if (!response.ok) {
        throw new Error("someThing went wrong");
      }

      //? get data
      const data = await response.json();

      //? if data is not ok throw error
      if (data.errors) {
        throw new Error(data.errors.map((err) => err.message).join(", "));
      }

      //? return data
      return data;
    } catch (error) {
      console.log("something went wrong loading collection products");
      throw error;
    }
  }

  // ? not used now
  renderSortByFilterOptions() {
    const sortbyFilterOptionsListEl = this.sortByFilterElement.querySelector(
      ".dropdown-filter__options-list"
    );

    //? loop the options
    this.sortByOptions.forEach((option) => {
      const html = ` <li data-value="${option.value}" class="dropdown-filter__option">
              <label class="dropdown-filter__option-label" for="${option.value}">
                <input
                  type="checkbox"
                  class="dropdown-filter__option-checkbox"
                  name="sort-by"
                  value="${option.value}"
                  id="${option.value}" />
                <span class="dropdown-filter__option-check-mark-icon"></span>
                ${option.label}
              </label>
            </li>`;

      sortbyFilterOptionsListEl.insertAdjacentHTML("beforeend", html);
    });
  }

  // ? render collection title
  renderCollectionTitle(title) {
    const searchParams = new URLSearchParams(window.location.search);

    //? if collection param exist
    if (searchParams.has("collection")) {
      this.collectionTitle.textContent = searchParams.get("collection");
      const breadcrumbLinkEl = this.collectionMetaEl.querySelector(
        ".collection__breadcrumb__link"
      );
      if (breadcrumbLinkEl) {
        breadcrumbLinkEl.textContent = searchParams.get("collection");
        breadcrumbLinkEl.href = `${window.location.origin}${
          window.location.pathname
        }?collection=${searchParams.get("collection").replaceAll(" ", "+")}`;

        //? remove hidden class
        breadcrumbLinkEl.classList.remove("hidden");
      }
      return;
    }

    //? set title
    this.collectionTitle.textContent = title;

    //? breadcrumb main link
    this.collectionMetaEl
      .querySelector(".collection__breadcrumb__link")
      ?.classList.remove("hidden");
  }

  //? render products
  renderProducts(products, container, append = false) {
    //? if products length is 0 info message
    if (!products.length) {
      this.renderErrorHandling("empty");
      container.innerHTML = "";
      return;
    } else {
      this.renderErrorHandling("none");
    }

    //?
    if (!append) {
      container.innerHTML = "";
    }

    products.forEach((product) => {
      // const productTitle =
      //   product.variants.nodes[0].title === "Default Title"
      //     ? product.title
      //     : product.variants.nodes[0].title;
       const productTitle = `${product.title && product.title} ${
        product.variants.nodes[0].title !== "Default Title" ?
        product.variants.nodes[0].title : ''
      }`;
      const price = this.getFormatPrice(
        product.variants.nodes[0].price.amount,
        this.localRegion[product.variants.nodes[0].price.currencyCode],
        product.variants.nodes[0].price.currencyCode
      );

      const variantId = product.variants.nodes[0].id
        .split("/")
        .filter(Boolean)
        .at(-1);

      //? is variant product
      // const isVariantProduct = product.variants.nodes.length > 1;
      // console.log("isVariantProduct", isVariantProduct)
      //? is in stock
      const isInStock = product.variants.nodes[0]?.availableForSale;

      //? images
      let productImages = [];

      // console.log("product", product)
      // console.log(location.hostname);
      // console.log(location.host);

      if (product.variants.nodes[0]?.metafield?.value) {
        const imagesString = product.variants.nodes[0]?.metafield?.value;
        productImages = imagesString.split(",").filter(Boolean);
      } else {
        const imagesString =
          product.metafields
            ?.filter(Boolean)
            .find((metafield) => metafield.key === "image_url")?.value || "";
        productImages = imagesString.split(",").filter(Boolean);
      }

      // console.log("productImages", productImages)
      //? use first metafield image as primary, or fallback to Shopify image
      let imageUrl = "";
      let imageAlt = product.title;
      if (productImages.length > 0) {
        imageUrl = productImages[0];
      } else if (product.images.nodes.length > 0) {
        imageUrl = product.images.nodes[0]?.url;
        imageAlt = product.images.nodes[0]?.altText || product.title;
      }

      //? is primary image exists
      let hasPrimaryImage = imageUrl !== "";

      //? get secondary image
      let secondaryImageUrl = "";
      let secondaryImageAlt = product.title;
      if (productImages.length > 1) {
        secondaryImageUrl = productImages[1];
      } else if (product.images.nodes.length > 1) {
        secondaryImageUrl = product.images.nodes[1]?.url;
        secondaryImageAlt = product.images.nodes[1]?.altText || product.title;
      }
      //? is secondary image exists
      let hasSecondaryImage = secondaryImageUrl !== "";

      //? metafields
      const manufacturer =
        product.metafields
          .filter(Boolean)
          .find((metafield) => metafield.key === "manufacturer")
          ?.value.replaceAll(" ", "-") || "";
      const model =
        product.metafields
          .filter(Boolean)
          .find((metafield) => metafield.key === "model")
          ?.value.replaceAll(" ", "-") || "";

      const html = ` <a href="/products/${product.handle}">
    <div class="product-card" data-manufacturer="${manufacturer}"
       data-model="${model}">
          <div class="product-card__image">
            ${
              hasPrimaryImage
                ? `<img
              src="${imageUrl}"
              width="300"
              height="300"
              loading="lazy"
              class="motion-reduce ${
                hasSecondaryImage ? "primary-image" : "featured-image"
              }"
              alt="${imageAlt}">`
                : `
                <svg
                  class="placeholder-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 525.5 525.5"
                >
                  <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path>
                  <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path>
                  <path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path>
                </svg>`
            }
            ${
              hasSecondaryImage
                ? `<img
              src="${secondaryImageUrl}"
              width="300"
              height="300"
              loading="lazy"
              class="motion-reduce secondary-image"
              alt="${secondaryImageAlt}">`
                : ""
            }
          </div>
          <div class="product-card__content">
            <div class="product-card__title-wrapper">
              <span class="product-card__manufacturer">${manufacturer}</span>
              <h3 class="product-card__title">${productTitle}</h3>
            </div>
            <div class="product-card__price-wrapper">
              <span class="product-card__price">
                ${price}
              </span>
              <button type="button" ${
                isInStock ? "" : "disabled"
              }  data-variant-id="${variantId}" class="product-card__add-to-cart">
               <span class="product-card__add-to-cart-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.1377 8L9.58597 2" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"></path>
                <path d="M17.8619 8L14.4136 2" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"></path>
                <path d="M20 10L19.204 18.7584C19.0893 20.0259 17.9333 21 16.5467 21H7.45333C6.06667 21 4.91067 20.0259 4.796 18.7584L4 10" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"></path>
                <path d="M2 9H22" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"></path>
              </svg></span>
              <span class="product-card__add-to-cart-loader"></span>
              </button>
            </div>
          </div>
        </div></a>`;

      container.insertAdjacentHTML("beforeend", html);
    });
  }

  //? render Pagination
  renderPagination(pageInfo) {
    this.PAGE_INFO = {
      hasNextPage: pageInfo.hasNextPage,
      hasPreviousPage: pageInfo.hasPreviousPage,
      startCursor: pageInfo.startCursor,
      endCursor: pageInfo.endCursor,
    };

    if (this.PAGE_INFO.hasNextPage) {
      this.loadMoreBtnWrapper.classList.remove("hidden");
    } else {
      this.loadMoreBtnWrapper.classList.add("hidden");
    }
  }

  //? render Metafields filters
  renderMetafieldsFilters(filters) {
    //? get metafields filters
    const metafieldsFilters = filters.filter((filter) =>
      this.metafieldFiltersIds.includes(filter.id)
    );
    //? return if no metafields filters
    if (metafieldsFilters.length === 0) return;
    //? render metafields filters
    if (metafieldsFilters.length >= 1) {
      metafieldsFilters.forEach((filter) => {
        this.renderMetafieldFieldFilterOptions(filter);
      });
    }
  }

  //? render metafield field options
  renderMetafieldFieldFilterOptions(filter) {
    const elementId = filter.id.split(".")[filter.id.split(".").length - 1];
    const filterEl = this.querySelector(`#${elementId}-filter`);

    if (filterEl) {
      //? get options list
      const optionsListEl = filterEl.querySelector(
        ".dropdown-filter__options-list"
      );

      //? clear options
      optionsListEl.innerHTML = "";

      //? if no options found disabled dropdown filter
      if (filter.values.length === 0) {
        filterEl.classList.add("disabled");
        return;
      }

      //? if filter element is model update options list only if option has mapped any product (count > 0)
      if (elementId === "model") {
        filter.values.forEach((value) => {
          if (value.count > 0) {
            const html = `<li role="option" data-filter-input=${value.input} data-count="${
              value.count
            }" class="dropdown-filter__option dropdown-filter__option--checkbox">
              <label class="dropdown-filter__option-label" for="${value.label.replaceAll(
                " ",
                "-"
              )}">
                <input
                  type="checkbox"
                  class="dropdown-filter__option-checkbox"
                  name="${elementId}"
                  data-count="${value.count}"
                  data-filter-input='${value.input}'
                  ${
                    this.getFilterIsApplied(elementId, value.label)
                      ? `checked=${true}`
                      : ""
                  }
                  value="${value.label}"
                  id="${value.label.replaceAll(" ", "-")}" />
                <span class="dropdown-filter__option-check-mark-icon"></span>
                ${value.label}
              </label>
            </li>`;

            optionsListEl.insertAdjacentHTML("beforeend", html);
          }
        });
        return;
      }

      //? other filters like manufacturer
      filter.values.forEach((value) => {
        const html = `<li role="option" data-filter-input=${value.input} data-count="${
          value.count
        }" class="dropdown-filter__option dropdown-filter__option--checkbox">
              <label class="dropdown-filter__option-label" for="${value.label.replaceAll(
                " ",
                "-"
              )}">
                <input
                  type="checkbox"
                  class="dropdown-filter__option-checkbox"
                  name="${elementId}"
                  data-count="${value.count}"
                  data-filter-input='${value.input}'
                  ${
                    this.getFilterIsApplied(elementId, value.label)
                      ? `checked=${true}`
                      : ""
                  }
                  value="${value.label}"
                  id="${value.label.replaceAll(" ", "-")}" />
                <span class="dropdown-filter__option-check-mark-icon"></span>
                ${value.label}
              </label>
            </li>`;

        optionsListEl.insertAdjacentHTML("beforeend", html);
      });
    }
  }

  //? if manufacturer filter is active and model filter is not active and check is there options checked then render model filter
  //? render model filter options
  renderModelFilter() {
    const brandCheckedInputs = this.brandFilterEl.querySelectorAll(
      'input[name="manufacturer"]:checked'
    );
    const modelOptionsList = this.modelFilterEl.querySelector(
      ".dropdown-filter__options-list"
    );
    const modelOptionsCount = modelOptionsList
      ? modelOptionsList.children.length
      : 0;

    const shouldEnableModelFilter =
      brandCheckedInputs.length > 0 && modelOptionsCount > 0;

    if (shouldEnableModelFilter) {
      this.modelFilterEl.classList.remove("disabled");
      this.modelFilterEl.setAttribute("aria-disabled", "false");
    } else {
      this.modelFilterEl.classList.add("disabled");
      this.modelFilterEl
        .querySelector(".dropdown-filter__trigger")
        .classList.remove("active");
      this.modelFilterEl
        .querySelector(".dropdown-filter__options")
        .classList.remove("open");
      this.modelFilterEl.setAttribute("aria-disabled", "true");
    }
  }

  //? render breadcrumb
  renderBreadcrumb() {
    const manufacturerFilterInputs =
      this.QUERY_VARIABLES.filters.filter(
        (filter) => filter?.productMetafield?.key === "manufacturer"
      ) || [];

    const modelFilterInputs =
      this.QUERY_VARIABLES.filters.filter(
        (filter) => filter?.productMetafield?.key === "model"
      ) || [];

    //? elements
    const brandBreadcrumbListEl = this.collectionMetaEl.querySelector(
      ".collection__breadcrumb__brand-filters .collection__breadcrumb__filter-list"
    );
    const modelBreadcrumbListEl = this.collectionMetaEl.querySelector(
      ".collection__breadcrumb__model-filters .collection__breadcrumb__filter-list"
    );

    brandBreadcrumbListEl.innerHTML = "";
    modelBreadcrumbListEl.innerHTML = "";

    if (manufacturerFilterInputs.length > 0) {
      //? show divider
      brandBreadcrumbListEl.previousElementSibling.classList.remove("hidden");

      //? model is active
      if (modelFilterInputs.length > 0) {
        manufacturerFilterInputs.forEach((filter, index, array) => {
          const manufacturer = filter.productMetafield.value;
          const html = `<li data-filter-input='${JSON.stringify(
            filter
          )}' class="collection__breadcrumb__filter-link">${manufacturer} ${
            array.length - 1 === index ? "" : ","
          }</li>`;
          brandBreadcrumbListEl.insertAdjacentHTML("beforeend", html);
        });
      } else {
        //? loop it
        manufacturerFilterInputs.forEach((filter, index, array) => {
          const manufacturer = filter.productMetafield.value;
          const html = `<li>${manufacturer} ${
            array.length - 1 === index ? "" : ","
          }</li>`;
          brandBreadcrumbListEl.insertAdjacentHTML("beforeend", html);
        });
      }
    } else {
      //? show divider
      brandBreadcrumbListEl.previousElementSibling.classList.add("hidden");
    }

    //? models breadcrumbs
    if (modelFilterInputs.length > 0) {
      //? show divider
      modelBreadcrumbListEl.previousElementSibling.classList.remove("hidden");

      //? loop it
      modelFilterInputs.forEach((filter, index, array) => {
        const model = filter.productMetafield.value;
        const productCard = this.productsContainer.querySelector(
          `.product-card[data-model='${model.replaceAll(" ", "-")}']`
        );

        if (productCard) {
          const manufacturer = productCard.getAttribute("data-manufacturer");
          const html = `<li> ${manufacturer?.replaceAll("-", " ")} ${model} ${
            array.length - 1 === index ? "" : ","
          }</li>`;
          modelBreadcrumbListEl.insertAdjacentHTML("beforeend", html);

          return;
        }

        const html = `<li> ${model} ${
          array.length - 1 === index ? "" : ","
        }</li>`;
        modelBreadcrumbListEl.insertAdjacentHTML("beforeend", html);
      });
    } else {
      //? show divider
      modelBreadcrumbListEl.previousElementSibling.classList.add("hidden");
    }
  }

  //? render applied filters list
  renderAppliedFiltersList() {
    const appliedFiltersListEl =
      this.appliedCollectionFiltersWrapper.querySelector(
        ".collection__applied-filters-list"
      );

    if (!appliedFiltersListEl) {
      return;
    }

    //? remove all applied filters
    appliedFiltersListEl.innerHTML = "";

    //? get applied filters
    const metaFilterIsApplied = this.QUERY_VARIABLES.filters.some((filter) => {
      return (
        filter?.productMetafield?.key === "manufacturer" ||
        filter?.productMetafield?.key === "model"
      );
    });

    const filtersList = metaFilterIsApplied
      ? this.QUERY_VARIABLES.filters.filter(
          (filter) =>
            filter?.productMetafield?.key === "manufacturer" ||
            filter?.productMetafield?.key === "model"
        )
      : [];

    //? if length is greater than 0
    if (filtersList.length > 0) {
      //? show applied filters wrapper
      this.appliedCollectionFiltersWrapper.classList.remove("hidden");

      //? clear icon svg
      const clearIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="black"/>
        <g clip-path="url(#clip0_7651_4207)">
        <path d="M11 5L5 11" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M5 5L11 11" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_7651_4207">
        <rect width="8" height="8" fill="white" transform="translate(4 4)"/>
        </clipPath>
        </defs>
        </svg>`;

      //? loop it
      filtersList.forEach((filter) => {
        let label = filter?.productMetafield?.value;

        if (filter?.productMetafield?.key === "model") {
          const model = filter.productMetafield.value;
          const productCard = this.productsContainer.querySelector(
            `.product-card[data-model='${model.replaceAll(" ", "-")}']`
          );
          //? if product card exists
          if (productCard) {
            const manufacturer = productCard.getAttribute("data-manufacturer");
            label = `${manufacturer?.replaceAll("-", " ")} ${model}`;
          }
        }

        //? if manufacturer
        const html = `<li>
        <span class="applied-filter-label">${label}</span>
        <span class="applied-filter-clear-icon" data-filter-input='${JSON.stringify(
          filter
        )}' data-type="${filter?.productMetafield?.key}" data-value="${
          filter?.productMetafield?.value
        }">
        ${clearIconSvg}
      </span></li>`;
        appliedFiltersListEl.insertAdjacentHTML("beforeend", html);
      });
    } else {
      //? hide applied filters wrapper
      this.appliedCollectionFiltersWrapper.classList.add("hidden");
    }
  }

  //? render page results
  renderPageResults(filters, productsCount = 0) {
    const response = filters.find(
      (filter) => filter.id === "filter.v.availability"
    );
    if (response && productsCount > 0) {
      this.RESULTS_COUNTS = {
        startCount: this.productsContainer.children.length >= 1 ? 1 : 0,
        total: response.values.reduce((acc, curr) => acc + curr.count, 0) || 0,
        endCount: this.productsContainer.children.length,
      };
    } else {
      this.RESULTS_COUNTS = {
        startCount: 0,
        total: 0,
        endCount: 0,
      };
    }

    const html = ` <span class="collection__results-count__count">${this.RESULTS_COUNTS.startCount}</span>
      <span class="collection__results-count__divider">-</span>
      <span class="collection__results-count__count">${this.RESULTS_COUNTS.endCount}</span>
      of
      <span class="collection__results-count__total">${this.RESULTS_COUNTS.total}</span>
      Results`;

    this.collectionMetaEl.querySelector(
      ".collection__results-count"
    ).innerHTML = html;
  }

  //? render error handling
  renderErrorHandling(type = "none") {
    const emptyProductsErrorHtml = `<div class="collection__info-box">
    <h2 class="collection__info-box-content">No products found
      <span>Use fewer filters or
        <a
          class="underlined-link link"
          style="font-size: inherit;"
          href="${window.location.pathname}">Remove all</a>
      </span>
    </h2>
  </div>`;
    //? load more,initial load, apply filters (like sort by, manufacturer, model)
    const otherErrors = `<div class="collection__info-box">
    <h2 class="collection__info-box-content">SomeThing Went Wrong
      <span>Please Try Again
        <a
          class="underlined-link link"
          style="font-size: inherit;"
          href="${window.location.pathname}">Refresh</a>
      </span>
    </h2>
  </div>`;

    //? remove old errors
    this.querySelectorAll(".collection__info-box")?.forEach((el) =>
      el?.remove()
    );

    if (type === "empty") {
      this.insertAdjacentHTML("beforeend", emptyProductsErrorHtml);
      return;
    } else if (type === "error") {
      this.productsContainer.innerHTML = "";
      this.collectionMetaEl.querySelector(
        ".collection__results-count"
      ).innerHTML = "";
      this.appliedCollectionFiltersWrapper.innerHTML = "";
      this.loadMoreBtnWrapper.classList.add("hidden");
      this.insertAdjacentHTML("beforeend", otherErrors);
    }
  }

  //? apply sort by
  async applySortBy() {
    try {
      this.QUERY_VARIABLES = {
        ...this.QUERY_VARIABLES,
        after: null,
      };

      const response = await this.getCollection(
        ...Object.values(this.QUERY_VARIABLES)
      );

      //? error handling
      if (response.data && response.data?.collection === null) {
        throw new Error("Collection not found");
      }

      this.updateUI(response);
    } catch (error) {
      console.error("Error applying sort by", error);
      this.renderErrorHandling("error");
    }
  }

  //? apply metafield filters
  async applyFilters() {
    try {
      this.QUERY_VARIABLES = {
        ...this.QUERY_VARIABLES,
        after: null,
      };

      const response = await this.getCollection(
        ...Object.values(this.QUERY_VARIABLES)
      );

      //? error handling
      if (response.data && response.data?.collection === null) {
        throw new Error("Collection not found");
      }

      this.updateUI(response, false);
      this.dispatchEvent(new CustomEvent("filter:applied", { bubbles: true }));
    } catch (error) {
      console.error("Error applying filters", error);
      this.renderErrorHandling("error");
    }
  }

  //? update url state
  updateUrlState() {
    //? sort by
    this.getSortByValueFromUrl();

    //? metafield filters
    this.getAppliedMetaFieldFiltersFromUrl();

    //? product type filter from url
    this.getAppliedProductTypeFilterFromUrl();

    //? page cursor
    this.getEndCursorFromUrl();

    //? collection handle
    this.QUERY_VARIABLES.handle =
      this.getCollectionHandle() || this.COLLECTION_HANDLE;
  }

  //? update UI
  updateUI(response, append = false) {
    //? render collection title
    const collectionTitle = response.data.collection.title;
    this.renderCollectionTitle(collectionTitle);

    //? hide loading spinner
    this.hideLoadingSpinner();

    //? render products
    const products = response.data.collection.products.nodes;
    this.renderProducts(products, this.productsContainer, append);

    //? render pagination
    const pageInfo = response.data.collection.products.pageInfo;
    this.renderPagination(pageInfo);

    //? render metafields filters
    const filters = response.data.collection.products.filters;
    this.renderMetafieldsFilters(filters);

    //? render model filter options
    this.renderModelFilter();

    //? render breadcrumb
    this.renderBreadcrumb();

    //? render applied filter list
    this.renderAppliedFiltersList();

    //? render page results
    this.renderPageResults(filters, products?.length);
  }

  //? update filter label
  updateMetafieldFilterLabel(key, defaultLabel, reset = false) {
    //? reset
    if (reset) {
      this.querySelector(`#${key}-filter`).querySelector(
        ".dropdown-filter__label"
      ).textContent = defaultLabel;
      return;
    }
    //? update

    this.querySelector(`#${key}-filter`).querySelector(
      ".dropdown-filter__label"
    ).textContent =
      this.CHECKED_FILTERS_VALUES[key].size <= 0
        ? `${defaultLabel}`
        : this.CHECKED_FILTERS_VALUES[key].size > 2
        ? [...this.CHECKED_FILTERS_VALUES[key]].slice(0, 2).join(", ") +
          ` ${"..."}`
        : [...this.CHECKED_FILTERS_VALUES[key]].join(", ");
  }

  //? hide loading spinner
  hideLoadingSpinner() {
    this.querySelector(".collection__loading").classList.add("hidden");
  }

  //? initial render
  async initialRender() {
    try {
      //? update url state if any search params exist
      this.updateUrlState();

      //? make api call
      const response = await this.getCollection(
        ...Object.values(this.QUERY_VARIABLES)
      );

      //? error handling
      if (response.data.collection === null) {
        throw new Error("Collection not found");
      }

      //? update ui
      this.updateUI(response);
    } catch (error) {
      console.log("error in initial render", error);
      this.renderErrorHandling("error");
    }
  }

  //? show load more spinner
  showLoadMoreBtnSpinner(loading = false) {
    if (loading) {
      this.loadMoreBtnWrapper.classList.add("collection__load-more--loading");
    } else {
      this.loadMoreBtnWrapper.classList.remove(
        "collection__load-more--loading"
      );
    }
  }

  //? preserve url search params and update url
  preserveUrlSearchParams(key, value, filterApplied = false) {
    const searchParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();

    //? if searchParams size > 0
    if (searchParams.size > 0) {
      searchParams.forEach((paramValue, paramKey) => {
        if (paramKey !== "phCursor" && paramKey !== key) {
          newParams.append(paramKey, paramValue);
        }
      });
    }

    //? if value exists update
    if (Array.isArray(value)) {
      value.forEach((val) => newParams.append(key, val));
    } else if (value && key !== "phCursor") {
      newParams.append(key, value);
    } else if (value && key === "phCursor") {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }

    //? remove phCursor when filter is applied
    if (filterApplied) {
      newParams.delete("phCursor");
    }

    //? update the url
    history.pushState(
      {},
      null,
      `${window.location.origin}${window.location.pathname}${
        newParams.toString().length > 0 ? "?" : ""
      }${newParams.toString()}`
    );
  }

  //? load more products
  async loadMoreProducts(endCursor) {
    try {
      //? show load more spinner
      this.showLoadMoreBtnSpinner(true);

      //? preserve url search params
      this.preserveUrlSearchParams("phCursor", endCursor);

      this.QUERY_VARIABLES = {
        ...this.QUERY_VARIABLES,
        after: endCursor,
      };

      const response = await this.getCollection(
        ...Object.values(this.QUERY_VARIABLES)
      );

      //? error handling
      if (response.data && response.data.collection === null) {
        throw new Error("Collection not found");
      }

      //? update ui
      this.updateUI(response, true);

      //? hide load more spinner
      this.showLoadMoreBtnSpinner(false);
    } catch (error) {
      console.log("error in load more", error);
      this.renderErrorHandling("error");
    }
  }

  //? show add to cart spinner
  showAddToCartSpinner(loading = false, addToCartBtn) {
    if (loading) {
      addToCartBtn.classList.add("product-card__add-to-cart--loading");
    } else {
      addToCartBtn.classList.remove("product-card__add-to-cart--loading");
    }
  }

  //? update cart notification
  updateCartNotification(response) {
    const cartNotification = document.querySelector("cart-notification");
    if (
      cartNotification &&
      typeof cartNotification.renderContents === "function"
    ) {
      cartNotification.renderContents(response);
    }
  }

  //? add to cart
  async addToCart(variantId, addToCartBtn) {
    try {
      //? show add to cart spinner
      this.showAddToCartSpinner(true, addToCartBtn);

      const response = await fetch(
        `${window.Shopify.routes.root}cart/add?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        }
      );

      if (!response.ok) throw new Error("Failed to add to cart");

      //? data
      const data = await response.json();

      //? update cart notification
      this.updateCartNotification(data);

      //? hide add to cart spinner
      this.showAddToCartSpinner(false, addToCartBtn);
    } catch (error) {
      console.log("error in add to cart", error);
      //?  errors found hide spinner
      this.showAddToCartSpinner(false, addToCartBtn);
    }
  }
}

customElements.define("collection-template", Collection);
